import { catalog } from "../i18n.js";

/** A bot's skills (components/Skills.tsx). Skill names, descriptions and bodies are the user's or the bot's words and stay as written. */
export const SKILLS = catalog(
  {
    title: "Skills",
    intro: (bot: string) => `Procedures ${bot} follows. Every prompt carries the name and the description; the instructions are read only when one is relevant. Folder: `,
    close: "Close",
    loading: "Loading…",
    empty: "No skills yet. Write one below, or drop a folder with a SKILL.md into that directory.",
    noDescription: "no description — the bot has little to go on",
    edit: "Edit",
    delete: "Delete",
    deleteTitle: (skill: string) => `Delete the skill "${skill}"?`,
    deleteMessage: "The bot no longer has it to follow. This cannot be undone.",
    newSkill: "New skill",
    name: "Name",
    namePlaceholder: "Release notes",
    whenToUse: "When to use it",
    whenToUseHint: "one line; this is what the bot chooses on, so say the trigger, not the contents",
    whenToUsePlaceholder: "Whenever I ask for release notes or a changelog entry",
    instructions: "Instructions",
    instructionsPlaceholder: "Write in the past tense.\nOne bullet per user-visible change.\nLink the pull request at the end of each bullet.",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
  },
  {
    title: "Keahlian",
    intro: (bot: string) => `Prosedur yang diikuti ${bot}. Nama dan deskripsinya ikut di setiap prompt; instruksinya baru dibaca saat keahlian itu relevan. Folder: `,
    close: "Tutup",
    loading: "Memuat…",
    empty: "Belum ada keahlian. Tulis satu di bawah, atau taruh folder berisi SKILL.md ke direktori itu.",
    noDescription: "tanpa deskripsi — bot hampir tidak punya pegangan",
    edit: "Ubah",
    delete: "Hapus",
    deleteTitle: (skill: string) => `Hapus keahlian "${skill}"?`,
    deleteMessage: "Bot tidak lagi punya keahlian ini untuk diikuti. Tindakan ini tidak bisa dibatalkan.",
    newSkill: "Keahlian baru",
    name: "Nama",
    namePlaceholder: "Catatan rilis",
    whenToUse: "Kapan dipakai",
    whenToUseHint: "satu baris; bot memilih berdasarkan ini, jadi tulis pemicunya, bukan isinya",
    whenToUsePlaceholder: "Setiap kali saya minta catatan rilis atau entri changelog",
    instructions: "Instruksi",
    instructionsPlaceholder: "Tulis sebagai hal yang sudah terjadi.\nSatu poin per perubahan yang terlihat pengguna.\nTautkan pull request di akhir setiap poin.",
    create: "Buat",
    save: "Simpan",
    cancel: "Batal",
  },
);
